export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-05-22T12:38:12Z';
export const COMMIT_HASH = '4b0a066d';
export const BUILD_DATE_UTC = '2026-05-22T12:38:12Z';
export const BUILD_DATE_IST = '2026-05-22T18:08:12+05:30';
export const ENVIRONMENT = 'stage';
